<script lang="ts">
	import SkeletonBlock from '$lib/components/atoms/skeleton/SkeletonBlock.svelte';
	import SkeletonText from '$lib/components/atoms/skeleton/SkeletonText.svelte';
</script>

<div class="grid gap-8">
	<div class="flex flex-col" data-testid="expense-note-skeleton">
		<div class="flex flex-col gap-1">
			<div class="flex justify-between">
				<SkeletonText minWords={1} maxWords={1} minWordLength={18} maxWordLength={22} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={6} maxWordLength={24} />
			</div>
			<div class="flex justify-between">
				<SkeletonText minWords={1} maxWords={1} minWordLength={12} maxWordLength={20} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={8} maxWordLength={16} />
			</div>
			<div class="flex justify-between">
				<SkeletonText minWords={1} maxWords={1} minWordLength={18} maxWordLength={22} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={6} maxWordLength={24} />
			</div>
			<div class="flex justify-between">
				<SkeletonText minWords={1} maxWords={1} minWordLength={22} maxWordLength={32} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={10} maxWordLength={14} />
			</div>
		</div>
		<div class="flex flex-col pt-4 gap-1">
			<div class="flex justify-between">
				<SkeletonText minWords={1} maxWords={1} minWordLength={18} maxWordLength={22} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={6} maxWordLength={24} />
			</div>
			<div class="flex justify-between">
				<SkeletonText minWords={1} maxWords={1} minWordLength={12} maxWordLength={20} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={8} maxWordLength={16} />
			</div>
			<SkeletonBlock width="100%" height="1px" borderRadius="0" />
			<div class="flex justify-between">
				<SkeletonText minWords={1} maxWords={1} minWordLength={12} maxWordLength={20} />
				<SkeletonText minWords={1} maxWords={1} minWordLength={8} maxWordLength={16} />
			</div>
		</div>
		<div class="flex flex-row pt-4 gap-2 w-50%">
			<SkeletonBlock width="50%" height="44px" borderRadius="4px" />
			<SkeletonBlock width="50%" height="44px" borderRadius="4px" />
		</div>
	</div>
</div>
